module.exports = __webpack_public_path__ + "static/media/Avatar_17.24056128.svg";